import { useAppDispatch, useAppSelector } from "../../app/hooks";
import SendIcon from "@mui/icons-material/Send";
import Grid2 from "@mui/material/Grid2";
import {
  Box,
  Button,
  Container,
  useMediaQuery,
  CircularProgress,
  useTheme,
  Typography,
} from "@mui/material";
import {
  adminPageInitialLoadAsync,
  prepareVoucherExportAsync,
  generateVouchersAsync,
  importAsync,
  selectState,
  setCompanyAsync,
  setProductAsync,
  setRequestedNumberOfVouchers,
} from "./AdministratorPageSlice";
import { useFilePicker } from "use-file-picker";
import { DropDownSelect } from "../../components/drop_down/DropDown";
import { useEffect } from "react";
import { store } from "../../app/store";
import { useCSVDownloader } from "react-papaparse";
import { Create, Download, UploadFileOutlined } from "@mui/icons-material";
import { CssTextField } from "../../components/custom_input/CustomInput";
export function AdministratorPage() {
  const dispatch = useAppDispatch();
  const state = useAppSelector(selectState);

  const theme = useTheme();
  const lessThanSm = useMediaQuery(theme.breakpoints.down("sm"));

  const { openFilePicker, filesContent, loading } = useFilePicker({
    accept: ".csv",
    onFilesSelected: ({ plainFiles, filesContent, errors }) => {
      // this callback is always called, even if there are errors
      console.log("onFilesSelected", plainFiles, filesContent, errors);

      var content = filesContent[0].content;
      dispatch(importAsync(content));
    },
  });

  const { CSVDownloader, Type } = useCSVDownloader();

  useEffect(() => {
    dispatch(adminPageInitialLoadAsync());
  }, []);

  return (
    <Container maxWidth="sm" disableGutters={lessThanSm}>
      <Box margin={5}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}>
        <Grid2 container>
          <Box
            sx={{
              height: "100vh",
              display: state.isLoading ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
            }}
          >
            <Grid2
              container
              direction="column"
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid2>
                <CircularProgress size={60} />
              </Grid2>
              <Grid2>
                <Typography>Processing</Typography>
              </Grid2>
            </Grid2>
          </Box>

          <Grid2
            container
            direction={"column"}
            spacing={2}
            sx={{ display: state.isLoading ? "none" : "flex" }}
          >
            {/* Import CSV*/}
            <Grid2>
              <DropDownSelect
                label="Company"
                value={state.selectedCompany}
                values={state.availableCompanies}
                displayMember="name"
                onChange={(x) => {
                  dispatch(setCompanyAsync(x.target.value));
                }}
              />
            </Grid2>
            <Grid2>
              <DropDownSelect
                label="Product"
                value={state.selectedProduct}
                values={state.availableProducts}
                displayMember="name"
                onChange={(x) => {
                  dispatch(setProductAsync(x.target.value));
                }}
              />
            </Grid2>
            <Grid2>
              <Typography
                sx={{
                  display: state.selectedProduct == null ? "none" : "flex",
                }}
              >
                Total Unassigned Keys: {state.unassignedProductKeys.length}{" "}
              </Typography>
            </Grid2>
            <Grid2>
              <Typography
                sx={{
                  display: state.selectedProduct == null ? "none" : "flex",
                }}
              >
                Total Unassigned Vouchers: {state.unassignedVouchers.length}
              </Typography>
            </Grid2>
            <Grid2>
              <Typography
                sx={{
                  display: state.selectedProduct == null ? "none" : "flex",
                }}
              >
                Total Unexported Vouchers: {state.unexportedVouchers.length}
              </Typography>
            </Grid2>

            <Grid2>
              <Typography margin={1} variant="h2">
                Import CSV
              </Typography>
              <Button
                component="label"
                variant="contained"
                startIcon={<UploadFileOutlined sx={{ color: "#FFFFFF" }} />}
                onClick={(e: any) => {
                  if (state.selectedCompany == null) return;
                  openFilePicker();
                }}
              >
                <Typography variant="h5">Upload Keys</Typography>
              </Button>
            </Grid2>

            <Grid2>
              <Typography margin={1} variant="h2">
                Generate Vouchers
              </Typography>
              <Typography margin={1}>Enter number of vouchers to generate</Typography>
              <CssTextField value={state.requestedNumberOfVouchers} onChange={(x) => {
                var number = Number(x.target.value);
                dispatch(setRequestedNumberOfVouchers(number));
              }} inputMode="numeric"></CssTextField>
              <Button
                component="label"
                variant="contained"
                startIcon={<Create sx={{ color: "#FFFFFF" }} />}
                onClick={(e: any) => {
                  dispatch(generateVouchersAsync());
                }}
              >
                <Typography variant="h5">Generate Vouchers</Typography>
              </Button>
            </Grid2>

            <Grid2>
              <Typography margin={1} variant="h2">
                Export Vouchers
              </Typography>
              <Button
                component="label"
                variant="contained"
                startIcon={<Download sx={{ color: "#FFFFFF" }} />}
                onClick={(e: any) => {
                  dispatch(prepareVoucherExportAsync());
                }}
              >
                <Typography variant="h5">Export Vouchers</Typography>
              </Button>

              <Typography
                sx={{
                  display:
                    state.voucherKeysForExport.length == 0 ? "none" : "flex",
                }}
              >
                Vouchers ready for download: {state.voucherKeysForExport.length}
              </Typography>

              <Grid2
                sx={{
                  display:
                    state.voucherKeysForExport.length == 0 ? "none" : "flex",
                }}
              >
                <CSVDownloader
                  type={Type.Button}
                  filename={state.selectedProduct?.name}
                  bom={true}
                  config={{
                    delimiter: ",",
                  }}
                  data={state.voucherKeysForExport}
                >
                  Download
                </CSVDownloader>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Box>
    </Container>
  );
}
